module.exports = __webpack_public_path__ + "static/media/neuronet@2x.b47dca9c.png";